<template>
  <TableComp
    :name="$t('global.dns-zone-txt-records')"
    :headers="headers"
    :status="status"
    :number-of-items="records.length"
    :empty-actions="getEmptyActions()"
    empty-image="dns-zone-records"
    :empty-message="$t('global.no-dns-zone-txt-records-message')"
    :header-actions="getHeaderActions()"
  >
    <template #desktop>
      <tr v-for="item in records" :key="item.id">
        <td>{{ getHostname(item) }}</td>
        <td class="text-center px-5" style="word-break: break-all; width: 50%;">
          {{ getValue(item) }}
        </td>
        <td class="text-center">{{ getTtl(item) }}</td>
        <td class="text-end actions">
          <div class="d-flex justify-content-end mr-4">
            <ThreeDotsMenu :items="getMenuItems(item)" />
          </div>
        </td>
      </tr>
    </template>
    <template #mobile>
      <TableMobileRow v-for="item in records" :key="item.id">
        <template #header>
          <div class="d-flex align-items-center">
            <div class="flex-fill align-items-center">{{ getHostname(item) }}</div>
            <div class="d-flex justify-content-center">
              <ThreeDotsMenu :items="getMenuItems(item)" />
            </div>
          </div>
        </template>
        <template #content>
          <div class="row">
            <div class="col">{{ $t("global.value") }}:</div>
            <div class="col" style="word-break: break-all;">{{ getValue(item) }}</div>
          </div>
          <div class="row">
            <div class="col">{{ $t("global.ttl") }}:</div>
            <div class="col">{{ getTtl(item) }}</div>
          </div>
        </template>
      </TableMobileRow>
    </template>
  </TableComp>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import DnsZoneTxtRecord from "@/components/smart/modals/DnsZoneTxtRecord";
import DnsZoneTxtRecordDelete from "@/components/smart/modals/DnsZoneTxtRecordDelete";
import NavLink from "@/classes/NavLink";
import store from "@/store";
import TableComp from "@/components/display/table/TableComp";
import TableHeader from "@/classes/TableHeader";
import TableMobileRow from "@/components/display/table/TableMobileRow";
import ThreeDotsMenu from "@/components/display/ThreeDotsMenu";

export default {
  name: "DnsZoneTxtRecords",
  props: {
    dnsZone: {
      type: Object,
      required: true,
    },
  },
  components: {
    TableComp,
    TableMobileRow,
    ThreeDotsMenu,
  },
  setup(props, { root }) {
    const records = computed(() => store.getters["dnsZoneTxtRecords/getList"]);
    const status = computed(() => store.getters["dnsZoneTxtRecords/getListStatus"]);

    const headers = [
      new TableHeader(root.$t("global.hostname"), undefined),
      new TableHeader(root.$t("global.value"), "justify-content-center"),
      new TableHeader(root.$t("global.ttl"), "justify-content-center"),
      new TableHeader(),
    ];

    const getEmptyActions = () => [
      new NavLink(
        root.$t("global.dns-zone-txt-record-add"),
        null,
        openAddForm,
        false,
        "primaryOutline",
        null,
        status.value.isLoading
      ),
    ];

    const getHostname = (item) => item?.hostname;
    const getValue = (item) => item?.value;
    const getTtl = (item) => item?.ttl;

    const getHeaderActions = () => [
      new NavLink(
        root.$t("global.dns-zone-txt-record"),
        "add",
        openAddForm,
        false,
        null,
        "epsilon"
      ),
    ];

    const getMenuItems = (item) => [
      new NavLink(root.$t("global.edit"), null, openEditForm(item), false, "default"),
      new NavLink(root.$t("global.delete"), null, openDeleteForm(item), false, "default"),
    ];

    const openAddForm = () =>
      store.dispatch("modals/open", {
        template: DnsZoneTxtRecord,
        data: { dnsZone: props.dnsZone, hostname: props.dnsZone.domain },
      });

    const openDeleteForm = (item) => () =>
      store.dispatch("modals/open", {
        template: DnsZoneTxtRecordDelete,
        data: { record: item },
      });

    const openEditForm = (item) => () =>
      store.dispatch("modals/open", {
        template: DnsZoneTxtRecord,
        data: {
          recordId: item.id,
          dnsZone: props.dnsZone,
          editing: true,
          hostname: item.hostname,
          value: item.value,
          ttl: item.ttl,
        },
      });

    onMounted(() => {
      store.dispatch("dnsZoneTxtRecords/getList", props.dnsZone.id);
    });

    return {
      headers,
      getEmptyActions,
      getHeaderActions,
      getHostname,
      getMenuItems,
      getTtl,
      getValue,
      records,
      status,
    };
  },
};
</script>
